import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../store/auth';
import { OnboardingShell } from '../../components/onboarding/OnboardingShell';
import styles from './Splash.module.css';

export function Splash(): JSX.Element {
  const status = useAuth((s) => s.status);
  const navigate = useNavigate();
  const { t } = useTranslation('flows');

  useEffect(() => {
    if (status !== 'authenticated') return;
    const t = setTimeout(() => navigate('/onboarding/language', { replace: true }), 600);
    return () => clearTimeout(t);
  }, [status, navigate]);

  const connecting = status !== 'authenticated';

  return (
    <OnboardingShell>
      <div className={styles.center}>
        <div
          className={styles.orb}
          data-testid="splash-orb"
          aria-hidden="true"
        >✦</div>
        <h1 className={styles.wordmark}>Calestea</h1>
        <p className={styles.tagline}>{t('onboarding.splash.tagline')}</p>
      </div>
      {connecting && (
        <div className={styles.connectingRow} aria-live="polite">
          <span className={styles.spinner} aria-hidden="true" />
          <span>{t('onboarding.splash.connecting')}</span>
        </div>
      )}
    </OnboardingShell>
  );
}
